module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isshow),
      expression: "isshow"
    }],
    staticClass: "modal"
  }, [_c('div', {
    staticClass: "ztx-modal"
  }), _vm._v(" "), _c('div', {
    staticClass: "ztx-message-box"
  }, [_c('div', {
    staticClass: "ztx-message-main"
  }, [_c('div', {
    staticClass: "ztx-message-tit"
  }, [_c('span', [_vm._v(_vm._s(_vm.modalTitle))]), _vm._v(" "), _c('div', {
    staticClass: "ztx-message-close",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.closeModal($event)
      }
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "ztx-messge-content"
  }, [_vm._t("modal-content")], 2), _vm._v(" "), _c('div', {
    staticClass: "ztx-message-btngroup"
  }, [_vm._t("modal-footer", [_c('button', {
    staticClass: "ztx-message-btn ztx-message-canbtn",
    on: {
      "click": _vm.cancelHander
    }
  }, [_vm._v(_vm._s(_vm.cancelButtonText))]), _vm._v(" "), _c('button', {
    staticClass: "ztx-message-btn ztx-message-okbtn",
    on: {
      "click": _vm.conformHander
    }
  }, [_vm._v(_vm._s(_vm.confirmButtonText))])])], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b4c75f8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modal.vue
// module id = 864
// module chunks = 1